module.exports = __webpack_public_path__ + "static/media/grunt.a459dc5a.png";